import Cache from 'root/cache';
import Form from 'root/module//form';
import Modals from 'root/modals';
import View from 'view/base';
import View_Project_Domains_Manage from 'view/project/domains_manage';
import View_Project_Page_Conditions from 'view/project/page_conditions';
import View_Widget_Trigger_Code from 'view/widget_trigger_code';

export default View.extend({
    views: {
        domains: {},
        widget_trigger_code: {}
    },

    events: {
        'click .update-click'    : 'onUpdateSettings',
        'keyup .update-keyup'    : 'onUpdateSettings',
        'change .update-change'  : 'onUpdateSettings',
        'click .user-segment'    : 'onSegmentSelect',
        'click .segment-create'  : 'onSegmentCreate',
        'click .segment-view'    : 'onSegmentView',
        'click .account-upgrade' : 'onAccountUpgrade'
    },

    dom_handlers: {
        onUpdateSettings: function(e) {
            // hack: wait for the dropdown and other ui modules to update in the UI first
            setTimeout(() => {
                var widget_settings = this.getSettings();
                this.model.set(widget_settings);
            });
        },

        onSegmentSelect: function(e) {
            // auto select radio button when a segment is selected
            Form.setData(this.$el, {
                user_segment: 1
            });
        },

        onSegmentCreate: function(e) {
            e.stopPropagation();
            Modals.createUserSegment();
        },

        onSegmentView: function(e) {
            e.preventDefault();

            var segment_id = this.$el.find('.user-segment-select li.selected').data('val');

            if (segment_id) {
                Modals.editUserSegment(segment_id);
            }
        },

        onAccountUpgrade: function(e) {
            Modals.choosePlan();
        }
    },

    event_handlers: {
        onSegmentAdd: function(model) {
            this.model.set('user_segment', model.id);
            this.renderSegmentDropdown();
        },

        onDomainChange: function() {
            this.trigger('Domain:Change');
        },

        onPageConditionChange: function() {
            this.model.set('page_condition', this.views.page_conditions.getData());
        },

        onTriggerTypeChange: function() {
            // active page conditions if trigger type is url_match
            this.$el.find('.region-page-conditions').toggleClass('active', this.model.get('trigger_type') === 'url_match');
        }
    },

    initialize: function() {
        this.views.domains = new View_Project_Domains_Manage({
            model: Cache.getDefaultProject(),
            show_save: false
        });

        this.views.page_conditions = new View_Project_Page_Conditions({
            data: this.model.get('page_condition'),
        });

        this.views.widget_trigger_code = new View_Widget_Trigger_Code({show_copy: false});

        this.listenTo(Cache.user_segment, 'add',    this.event_handlers.onSegmentAdd);
        this.listenTo(Cache.user_segment, 'change', this.renderSegmentDropdown); // segment name change
        this.listenTo(this.views.domains, 'change', this.event_handlers.onDomainChange);
        this.listenTo(this.views.page_conditions, 'change', this.event_handlers.onPageConditionChange);
        this.listenTo(this.model, 'change:trigger_type', this.event_handlers.onTriggerTypeChange);
    },

    getSettings: function() {
        var form_data = Form.getData(this.$el);

        var user_segment = 0;

        if (form_data.user_segment == 1) {
            user_segment = this.$el.find('.user-segment-select li.selected').data('val');
        }

        return {
            device_type     : form_data.device_type.join(','),
            trigger_type    : form_data.trigger_type,
            user_segment    : user_segment || 0,
            page_load_delay : form_data.page_load_delay
        };
    },

    getDomains: function() {
        return this.views.domains.getData();
    },

    getPageCondition: function() {
        return this.views.page_conditions.getData();
    },

    renderSegmentDropdown: function() {
        var user_segment_options = '';
        Cache.user_segment.where({is_archived: false}).forEach((segment) => {
            user_segment_options +=
            '<li data-val="' + segment.id + '" class="user-segment update-click' + (segment.id === this.model.get('user_segment') ? ' selected' : '') + '">' + segment.escape('segment_name') + '</li>';
        });

        var selected_segment;
        var selected_segment_name = '<span class="placeholder-text">Select a segment...</span>';

        if (this.model.get('user_segment')) {
            selected_segment = Cache.user_segment.get(this.model.get('user_segment'));

            if (selected_segment) {
                selected_segment_name = selected_segment.escape('segment_name');
            } else {
                selected_segment_name = '<span class="placeholder-text">Deleted segment</span>';
            }
        }

        var html =
        '<div class="button-dropdown" data-update="true">' +
            (selected_segment && selected_segment.get('is_archived') ?
            '<button type="button" class="dropdown-select tooltip" data-title="Segment is deactivated"><i class="fa-solid fa-circle-exclamation text-warning"></i> ' + selected_segment_name + '</button>' :
            '<button type="button" class="dropdown-select">' + selected_segment_name + '</button>') +
            '<div>' +
                (user_segment_options ?
                '<ul class="dropdown dropdown-select">' +
                    user_segment_options +
                '</ul>' :
                '<ul class="dropdown"><li class="disabled">No user segments created</li></ul>') +
                '<div>' +
                    '<button type="button" class="segment-create text-link text-align-left full small"><i class="fa-solid fa-plus margin-right-4"></i>New Segment</button>' +
                '</div>' +
            '</div>' +
        '</div>';

        this.$el.find('.user-segment-select').html(html);

        if (!Cache.account.hasFeature('segment_targeting')) {
            this.$el.find('.user-segment-select button.dropdown-select').prop('disabled', true);
            this.$el.find('input[name="user_segment"][value="1"]').prop('disabled', true);
        }

        Form.setData(this.$el.find('.region-widget-edit'), {
            user_segment: this.model.get('user_segment') ? 1 : 0
        });
    },

    render: function() {
        var content =
        '<div class="setting-title">Domains</div>' +
        '<div class="setting-subtitle">Add domains for where the widget will be installed</div>' +
        '<div class="divider-12"></div>' +
        '<div class="region-domains"></div>' +
        '<hr class="medium">' +

        '<div class="setting-title">Segments</div>' +
        '<div class="setting-subtitle">Select who will see the launcher</div>' +
        '<div class="divider-12"></div>' +
        '<div>' +
            '<input type="radio" name="user_segment" id="user_segment_all" class="update-click" value="0">' +
            '<label for="user_segment_all">All users</label>' +
        '</div>' +
        '<div class="divider-8"></div>' +
        '<div>' +
            '<input type="radio" name="user_segment" id="user_segment_1" class="update-click" value="1">' +
            '<label for="user_segment_1">Users in a segment:</label>' +
            '<div class="user-segment-select"></div>' +
            (Cache.account.hasFeature('segment_targeting') ?
            '<a href="#" class="segment-view margin-left-8"><i class="fa-solid fa-eye"></i></a>' :
            '<button type="button" class="account-upgrade shiny tiny margin-left-12"><span>UPGRADE</span></button>') +
        '</div>' +

        '<hr class="medium">' +

        '<div class="setting-title">Pages</div>' +
        '<div class="setting-subtitle">Select where the launcher is displayed</div>' +
        '<div class="divider-12"></div>' +
        '<div>' +
            '<input type="radio" name="trigger_type" id="trigger_type_1" class="update-click" value="page_load">' +
            '<label for="trigger_type_1">On all pages where the widget code is installed</label>' +
        '</div>' +
        '<div class="divider-8"></div>' +
        '<div>' +
            '<input type="radio" name="trigger_type" id="trigger_type_2" class="update-click" value="url_match">' +
            '<label for="trigger_type_2">On specific pages based on URL</label>' +
            '<div class="region-page-conditions"></div>' +
        '</div>' +
        '<div class="divider-8"></div>' +
        '<div>' +
            '<input type="radio" name="trigger_type" id="trigger_type_3" class="update-click" value="widget_url">' +
            '<label for="trigger_type_3">When query string is added</label>' +
            '<div class="region-widget-trigger-code"></div>' +
        '</div>' +
        '<div class="divider-8"></div>' +
        '<div>' +
            '<input type="radio" name="trigger_type" id="trigger_type_4" class="update-click" value="api">' +
            '<label for="trigger_type_4">Do not display the launcher</label>' +
            '<div class="launcher-api-help">Build your own widget button using <a class="primary" href="https://docs.userback.io/docs/bind-widget-to-button" target="help" rel="noopener">JavaScript SDK <i class="fa-solid fa-up-right-from-square fa-xs"></i></a>.</div>' +
        '</div>' +

        '<hr class="medium">' +

        '<div class="setting-title">Device</div>' +
        '<div class="setting-subtitle">Select devices for the form to display (select at least one)</div>' +
        '<div class="divider-12"></div>' +
        '<div>' +
            '<input type="checkbox" name="device_type" id="device_type_1" class="update-click" value="desktop">' +
            '<label for="device_type_1">Desktop</label>' +
            '<input type="checkbox" name="device_type" id="device_type_2" class="update-click" value="tablet">' +
            '<label for="device_type_2">Tablet</label>' +
            '<input type="checkbox" name="device_type" id="device_type_3" class="update-click" value="phone">' +
            '<label for="device_type_3">Mobile</label>' +
        '</div>' +

        '<hr class="medium">' +

        '<div class="setting-title">Delay</div>' +
        '<div class="setting-subtitle">Set when the launcher is displayed</div>' +
        '<div class="divider-12"></div>' +

        '<input type="number" name="page_load_delay" min="0" max="600" class="update-input solid compact short"> seconds after page is loaded';

        this.$el.html(content);

        this.views.domains.render().$el.appendTo(this.$el.find('.region-domains'));
        this.views.page_conditions.render().$el.appendTo(this.$el.find('.region-page-conditions'));
        this.$el.find('.region-page-conditions').toggleClass('active', this.model.get('trigger_type') === 'url_match');

        Form.setData(this.$el, {
            trigger_type    : this.model.get('trigger_type'),
            page_load_delay : this.model.get('page_load_delay'),
            device_type     : this.model.get('device_type') ? this.model.get('device_type').split(',') : [],
            user_segment    : this.model.get('user_segment') ? 1 : 0
        });

        // targeting
        this.views.widget_trigger_code.render().$el.appendTo(this.$el.find('.region-widget-trigger-code'));

        this.renderSegmentDropdown();

        return this;
    }
});